import React, { ButtonHTMLAttributes, ReactNode } from 'react';

type PrimaryButtonVariants = 'default' | 'outlined';

export interface PrimaryButtonProps
  extends ButtonHTMLAttributes<HTMLButtonElement> {
  children?: ReactNode;
  className?: string;
  variant?: PrimaryButtonVariants;
  disabled?: boolean;
}

// For now, style variables must all be one line due to third party analytics issues with classLists containing too much whitespace between classes
/* Default styles for primary buttons. */
const primaryDefaultStyle = `bg-thryv-orange-500 text-white text-btn-text font-open-sans font-semibold capitalize rounded hover:bg-thryv-orange-700 disabled:bg-thryv-gray-light-500 min-w-[89px] border border-thryv-orange-500 disabled:border-thryv-gray-light-500 hover:border-thryv-orange-700`;

/* Outlined styles for primary buttons */
const primaryOutlinedStyle = `bg-transparent text-thryv-orange-600 text-btn-text border border-thryv-orange-600 font-open-sans font-semibold capitalize rounded hover:bg-thryv-orange-500 hover:text-white disabled:bg-transparent disabled:border-thryv-gray-medium-300 disabled:text-thryv-gray-medium-400`;

export const PrimaryButton = ({
  children,
  className,
  variant = 'default',
  disabled = false,
  type = 'button',
  ...rest
}: PrimaryButtonProps) => {
  const getVariantStyle = () => {
    if (variant === 'default') {
      return primaryDefaultStyle;
    } else if (variant === 'outlined') {
      return primaryOutlinedStyle;
    } else {
      return primaryDefaultStyle;
    }
  };

  const handleClassList = () => {
    const variantStyle = getVariantStyle();
    if (className) {
      return `${variantStyle} ${className}`;
    } else {
      return variantStyle;
    }
  };
  return (
    <button
      type={type}
      disabled={disabled}
      className={`px-4 py-1.75 transition duration-200 ease-in-out ${handleClassList()}`}
      {...rest}
    >
      {children}
    </button>
  );
};
